import { assign } from '../assign';
import { checkIsWbMask } from '../check-is-wb-mask';

export const redirect = (): void => {
  const url = new URL(window.location.href);

  const redirectUrl = decodeURIComponent(
    url.searchParams.get('redirect_url') || window.location.origin,
  );

  const isWBMask = checkIsWbMask(redirectUrl);

  const newUrl = new URL(isWBMask ? redirectUrl : url.origin);

  newUrl.searchParams.set('fromSellerLanding', '');

  assign(newUrl);
};
